module.exports = __webpack_public_path__ + "img/GS.46d87298.png";